import React from 'react';
import styled from 'styled-components';
import { Card } from 'styleguide/Card';
import { DoubleCircledIcon } from 'styleguide/CircledIcons';
import { P1, P2 } from 'styleguide/Texts';
import { Spacing } from 'styleguide/spacing';
import { t } from 'translations/t';

const Container = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 240px;
  padding: ${Spacing.lg}px;
  margin-top: ${Spacing.lg}px;
  gap: ${Spacing.lg}px;
`;

interface Props {
  username: string;
}

export const ZeroWorkouts = ({ username }: Props) => {
  return (
    <>
      <P1>{t('global.workouts')}</P1>
      <Container>
        <DoubleCircledIcon type="exercise"></DoubleCircledIcon>
        <P2>{t('web.profile.zeroWorkouts.hasntWorkedOut', { username })}</P2>
      </Container>
    </>
  );
};
